module.exports = __webpack_public_path__ + "exstrahlen-mockup.svg?c4df8939a40d70450100b9cd1ed36ae7";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/exstrahlen-mockup.svg
// module id = 313
// module chunks = 0